import cn from 'classnames';
import { useContext, useState } from 'react';
import { useLocation } from 'react-router';

import Button from 'components/common/Button';
import CloseX from 'components/icons/navigation/CloseX';
import { VoucherContext } from 'components/signUpFunnel/Contexts';
import { BrandContext, HOME_CHEF } from 'context/BrandContext';
import localStorage from 'helpers/localStorage';
import * as Routes from 'helpers/routes';
import useAmexBCE from 'hooks/useAmexBCE';
import useBrand from 'hooks/useBrand';
import useUsaa from 'hooks/useUsaa';
import { SHOW_PROMO_BANNER_LOCAL_STORAGE } from 'lib/constants/signUp';

import AmexBCEBanner from './AmexBCEBanner';
import UsaaBanner from './UsaaBanner';

const Banner = () => {
  const { voucher, fuelVoucherCodes } = useContext(VoucherContext);
  const { brand } = useContext(BrandContext);
  const [closeBannerClicked, setCloseBannerClicked] = useState(false);

  const isAmexUser = useAmexBCE();
  const location = useLocation();
  const isUsaa = useUsaa();
  const isHomeChef = useBrand(HOME_CHEF);
  const isPickYourMeals = location.pathname.includes(Routes.PICK_MEALS_MENU_PATH);

  const [fuelCodes] = fuelVoucherCodes;

  const showPromoBanner = localStorage.read(SHOW_PROMO_BANNER_LOCAL_STORAGE);

  if (
    voucher?.isIdMeMilitaryHealthTeacher ||
    voucher?.isIdMeStudentAlumniGov ||
    voucher?.isCourtesyVoucher ||
    location.pathname === Routes.getBrandRoute({ brand: brand }).thankyou
  )
    return null;

  if (isUsaa) return <UsaaBanner />;
  if (isAmexUser && isHomeChef) return <AmexBCEBanner />;

  const Heading = () => {
    return (
      <p className="mb-0 flex-auto text-center">
        {fuelCodes.includes(voucher?.code)
          ? `Success! Use discount code ${voucher?.code} at checkout to receive your discount`
          : voucher?.welcomeMessage}
      </p>
    );
  };

  const shouldShowBanner = () => showPromoBanner && !closeBannerClicked && voucher?.code;

  return shouldShowBanner() ? (
    <section
      className={cn('text flex items-center px-1 py-2 bp1:px-4', {
        'bg-tempo-blue-120 text-white-100': !isHomeChef && !isPickYourMeals,
        'bg-green-100 text-white-100': isHomeChef && !isPickYourMeals,
        'text-secondary bg-tempo-green-100': isPickYourMeals,
      })}
    >
      <Heading />
      <Button
        variation="Ghost"
        className="self-start border-none"
        onClick={() => setCloseBannerClicked(true)}
      >
        <CloseX className={`w-6 ${isPickYourMeals ? 'text-secondary' : 'text-white-100'}`} />
        <span className="sr-only">Close</span>
      </Button>
    </section>
  ) : null;
};

export default Banner;
